import { customersQuery } from "@common/api"
import type { CustomerPublic } from "@common/client"
import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import type { FieldValues, Path } from "react-hook-form"
import { type Option, SelectField } from "../fields/select"

type Props<T extends FieldValues> = {
  name: Path<T>
  label?: string
  className?: string
  optional?: boolean
  clearable?: boolean
}

export function customerOption(customer: CustomerPublic): Option<string> {
  return {
    value: customer.id,
    label: customer.name ?? customer.email ?? customer.id,
  }
}

export function CustomerField<T extends FieldValues>({
  name,
  label = "Customer",
  className,
  optional,
  clearable,
}: Props<T>) {
  const { data, isLoading } = useQuery(customersQuery({}))

  const options = useMemo(() => (data?.data ?? []).map(customerOption), [data])

  return (
    <SelectField<T>
      name={name}
      label={label}
      className={className}
      disabled={isLoading}
      placeholder={isLoading ? "Loading…" : "Select customer"}
      options={options}
      optional={optional}
      clearable={clearable}
    />
  )
}
